module.exports = __webpack_public_path__ + "static/media/social4.60703d7c.svg";